import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useMemo } from 'react';
import { DEFAULT_VIEW_ID_TO_ID_LABEL } from '../ViewTabs/constants/views';
import { jsx as _jsx } from "react/jsx-runtime";
const OUT_OF_CONTEXT_FLAG = 'OUT_OF_CONTEXT_FLAG';
const ListingContext = /*#__PURE__*/createContext(OUT_OF_CONTEXT_FLAG);
const ViewsPropsContext = /*#__PURE__*/createContext(OUT_OF_CONTEXT_FLAG);
const UiModePropsContext = /*#__PURE__*/createContext(OUT_OF_CONTEXT_FLAG);
export default function ListingProvider(t0) {
  "use memo";

  const $ = _c(17);
  const {
    children,
    enableObjectLevelPermissions,
    objectType,
    uiModeProps,
    viewProps,
    skipCrm,
    _useNonGqlCRMSearch
  } = t0;
  let t1;
  if ($[0] !== _useNonGqlCRMSearch || $[1] !== enableObjectLevelPermissions || $[2] !== objectType || $[3] !== skipCrm) {
    t1 = {
      enableObjectLevelPermissions,
      objectType,
      skipCrm,
      _useNonGqlCRMSearch
    };
    $[0] = _useNonGqlCRMSearch;
    $[1] = enableObjectLevelPermissions;
    $[2] = objectType;
    $[3] = skipCrm;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const stableValue = t1;
  let t2;
  bb0: {
    if (!viewProps) {
      t2 = undefined;
      break bb0;
    }
    if (viewProps.currentViewId && DEFAULT_VIEW_ID_TO_ID_LABEL[viewProps.currentViewId]) {
      const t3 = DEFAULT_VIEW_ID_TO_ID_LABEL[viewProps.currentViewId];
      let t4;
      if ($[5] !== t3 || $[6] !== viewProps) {
        t4 = Object.assign({}, viewProps, {
          currentViewId: t3
        });
        $[5] = t3;
        $[6] = viewProps;
        $[7] = t4;
      } else {
        t4 = $[7];
      }
      t2 = t4;
      break bb0;
    }
    t2 = viewProps;
  }
  const viewPropsWithIdLabel = t2;
  let t3;
  if ($[8] !== children || $[9] !== stableValue) {
    t3 = /*#__PURE__*/_jsx(ListingContext.Provider, {
      value: stableValue,
      children: children
    });
    $[8] = children;
    $[9] = stableValue;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3 || $[12] !== uiModeProps) {
    t4 = /*#__PURE__*/_jsx(UiModePropsContext.Provider, {
      value: uiModeProps,
      children: t3
    });
    $[11] = t3;
    $[12] = uiModeProps;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4 || $[15] !== viewPropsWithIdLabel) {
    t5 = /*#__PURE__*/_jsx(ViewsPropsContext.Provider, {
      value: viewPropsWithIdLabel,
      children: t4
    });
    $[14] = t4;
    $[15] = viewPropsWithIdLabel;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export function useListing() {
  "use memo";

  const context = useContext(ListingContext);
  if (context === OUT_OF_CONTEXT_FLAG) {
    throw new Error("useListing must be used within a ListingProvider");
  }
  return context;
}
export function useViewProps() {
  "use memo";

  const context = useContext(ViewsPropsContext);
  if (context === OUT_OF_CONTEXT_FLAG) {
    throw new Error("useViewProps must be used within a ListingProvider");
  }
  return context;
}
export function useUiModeProps() {
  "use memo";

  const context = useContext(UiModePropsContext);
  if (context === OUT_OF_CONTEXT_FLAG) {
    throw new Error("useUiModeProps must be used within a ListingProvider");
  }
  return context;
}